import {
  WORKFLOW_EDIT_DIALOG_MESSAGES,
  WorkflowEditDialogMessages,
} from "./workflow-edit-dialog.messages";
import { WORKFLOW_FILTERS_MESSAGES, WorkflowFiltersMessages } from "./workflow-filters.messages";
import { WORKFLOW_REQUEST_MESSAGES, WorkflowRequestMessages } from "./workflow-request-messages";
import {
  WORKFLOW_SAVE_DIALOG_MESSAGES,
  WorkflowSaveDialogMessages,
} from "./workflow-save-dialog.messages";
import { WORKFLOW_TABLE_MESSAGES, WorkflowTableMessages } from "./workflow-table.messages";
import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";
import { POPOVER_MESSAGES, PopoverMessages } from "../popover.messages";

export type WorkflowMessages = SidebarMessages &
  PopoverMessages &
  WorkflowFiltersMessages &
  WorkflowSaveDialogMessages &
  WorkflowEditDialogMessages &
  WorkflowSaveDialogMessages &
  WorkflowTableMessages &
  WorkflowRequestMessages & {
    // Titles
    pageTitle: string;
    workflowTitle: string;
    breadCrumbTitle: string;
    workflowTableTitle: string;
    updateWorkflowPageTitle: string;
    workflowCardTitle: string;

    //Button Messages
    activeButton: string;
  };

export const WORKFLOW_MESSAGES: WorkflowMessages = {
  // Titles
  pageTitle: "Agente",
  workflowTitle: "Agentes",
  breadCrumbTitle: "Agentes",
  workflowTableTitle: "Listagem de agentes",
  updateWorkflowPageTitle: "Editar etapas do agente.",
  workflowCardTitle: "Agente",

  //Button Messages
  activeButton: "Novo agente",
  ...SIDEBAR_MESSAGES,
  ...WORKFLOW_TABLE_MESSAGES,
  ...WORKFLOW_EDIT_DIALOG_MESSAGES,
  ...POPOVER_MESSAGES,
  ...WORKFLOW_FILTERS_MESSAGES,
  ...WORKFLOW_SAVE_DIALOG_MESSAGES,
  ...WORKFLOW_REQUEST_MESSAGES,
};

export default WORKFLOW_MESSAGES;
